package org.example.project.login

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

/** Website footer for the signed-out entry screens. Links work on every node host. */
@Composable
fun PublicWebsiteFooter(compact: Boolean) {
    Footer(attrs = {
        classes("public-website-footer")
        if (compact) classes("public-website-footer--compact")
    }) {
        Div({ classes("site-footer-inner") }) {
            Div({ classes("site-footer-row") }) {
                Div({ classes("site-footer-brand") }) {
                    A(href = "https://lumatica.de/", attrs = {
                        classes("site-footer-logo")
                        attr("aria-label", "lumatica Home")
                    }) {
                        Img(src = "/images/logo_lumatica_white.png", alt = "lumatica", attrs = {
                            attr("width", "141")
                            attr("height", "22")
                        })
                    }
                    P({ classes("site-footer-slogan") }) { Text("Erlebe den Unterschied") }
                }
                Nav(attrs = {
                    classes("site-footer-links")
                    attr("aria-label", "Footer")
                }) {
                    listOf(
                        "preise-service.html" to "Preise",
                        "ueber-uns.html" to "Über uns",
                        "roi.html" to "ROI",
                        "datenschutz.html" to "Datenschutz",
                        "impressum.html" to "Impressum"
                    ).forEach { (page, label) ->
                        A(href = "https://lumatica.de/footer/$page") { Text(label) }
                    }
                }
            }
        }
    }
}
